import { render } from "./reservation_card.vue?vue&type=template&id=3107a02e"
import script from "./reservation_card.vue?vue&type=script&lang=js"
export * from "./reservation_card.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__